// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid_GQjAw {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 300px 300px 300px;
  column-gap: 30px;
  row-gap: 30px;
  padding: 30px;
}

.area_SThCL {
  background-color: #f9fafb;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/roomOccupancy/RoomOccupancy.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0BAA0B;EAC1B,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: auto 300px 300px 300px;\n  column-gap: 30px;\n  row-gap: 30px;\n  padding: 30px;\n}\n\n.area {\n  background-color: #f9fafb;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `grid_GQjAw`,
	"area": `area_SThCL`
};
export default ___CSS_LOADER_EXPORT___;
